import {PageTitle} from 'layout/master-layout'
import React from 'react'
import {useParams} from 'react-router-dom'
import TicketDetailData from '../components/TicketDetailData'

const TicketDetail = () => {
 const {id} = useParams<{id: string}>()

 if (!id) {
  return null
 }

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    <PageTitle
     breadcrumbContainerClass='flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
     breadcrumbs={[
      {
       title: 'Home',
       path: '/home-page',
       isActive: false,
      },
      {
       title: 'All Tickets',
       path: '/all-tickets',
       isActive: false,
      },
      {
       title: id ?? '',
       path: '',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     Ticket Details
    </PageTitle>

    <hr className='mb-6' />
    <TicketDetailData ticketId={id} />
   </div>
  </div>
 )
}

export default TicketDetail
